import React from 'react';

function AgeDistributionCakeGraphic({ label = '', color = '', gender = '', image = '', percentage = '' }) {
  const styling = {
    stroke: color,
    strokeDasharray: `${101} 100`
  };

  return (
    <div
      className="circular-progress col-md-12 col-sm-12 col-12"
      style={{ justifyContent: 'left', marginLeft: '-5px' }}
    >
      <div className="Percentage">
        <svg width="80" height="80">
          <circle className="circle" r="30%" cx="50%" cy="50%" pathLength="100" style={styling} />
        </svg>
        <span style={{ color: '#f8c444' }}>
          <img src={image} alt="MenImage.png" />
        </span>
      </div>
      <p style={{ fontWeight: 'bold', fontSize: '12px' }}>
        {gender} {label} = {percentage}
      </p>
    </div>
  );
}

export default AgeDistributionCakeGraphic;
